import React from 'react';
import { Gutter, ModalSection, Suspense, TabsItem, Tabs } from '@axiom/ui';

import { AdminModalLawSchoolsView } from './AdminModalLawSchoolsView';
import { AdminModalAreasOfStudyView } from './AdminModalAreasOfStudyView';
import { AdminModalUsersView } from './AdminModalUsersView';
import { AdminModalTagsView } from './AdminModalTagsView';

export const AdminModal = () => {
  return (
    <ModalSection name="ADMIN_FUNC_SECTION">
      <Tabs>
        <TabsItem name="USERS" label="Users">
          <Gutter bottom="8px" />
          <Suspense>
            <AdminModalUsersView />
          </Suspense>
        </TabsItem>
        <TabsItem name="TAGS" label="Tags">
          <Gutter bottom="8px" />
          <Suspense>
            <AdminModalTagsView />
          </Suspense>
        </TabsItem>
        <TabsItem name="SCHOOLS" label="Schools">
          <Gutter bottom="8px" />
          <Suspense>
            <AdminModalLawSchoolsView />
          </Suspense>
        </TabsItem>
        <TabsItem name="AREA_OF_STUDY" label="Area of Study">
          <Gutter bottom="8px" />
          <Suspense>
            <AdminModalAreasOfStudyView />
          </Suspense>
        </TabsItem>
      </Tabs>
    </ModalSection>
  );
};
